import {
	infiniteQueryOptions,
	queryOptions,
	useInfiniteQuery,
	useQuery,
} from "@tanstack/react-query"
import { getLocale } from "@/shared/lib/i18n"
import { streamKeys } from "../model/keys"
import type { StreamPage } from "../model/types"
import { setStreamHasNew } from "./cache"
import { getStreamHasNew, getStreamPage } from "./client"

const STREAM_PAGE_SIZE = 50

function getOlderStreamCursor(lastPage: StreamPage): number | undefined {
	if (lastPage.has_more_before && lastPage.next_before_id !== null) {
		return lastPage.next_before_id
	}
	return undefined
}

function streamMessagesQueryOptions() {
	return infiniteQueryOptions({
		queryKey: streamKeys.messageList(getLocale()),
		queryFn: async ({ pageParam, client }) => {
			const page = await getStreamPage({
				limit: STREAM_PAGE_SIZE,
				before: pageParam,
			})
			if (pageParam === null) setStreamHasNew(client, false)
			return page
		},
		initialPageParam: null as number | null,
		getNextPageParam: getOlderStreamCursor,
		refetchOnMount: "always",
		staleTime: 0,
	})
}

function streamStatusQueryOptions() {
	return queryOptions({
		queryKey: streamKeys.status(getLocale()),
		queryFn: getStreamHasNew,
	})
}

export function useStreamMessages() {
	return useInfiniteQuery(streamMessagesQueryOptions())
}

export function useStreamHasNew(enabled: boolean): boolean {
	const { data } = useQuery({ ...streamStatusQueryOptions(), enabled })
	return data ?? false
}
